// extracted by mini-css-extract-plugin
var _1 = "grid__WHkyH";
var _2 = "gridTablet__IXtNb";
export { _1 as "grid", _2 as "gridTablet" }
